import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { SectionActions } from '../styled';
import { ActionButtonsProps } from '../types/MarksAnalyticsTypes';

const ActionButtons: React.FC<ActionButtonsProps> = ({
  canGenerateOrDownload,
  isGenerating,
  isDownloading,
  onGenerate,
  onDownload
}) => (
  <SectionActions>
    <Button
      variant='contained'
      disabled={!canGenerateOrDownload || isGenerating}
      onClick={onGenerate}
      sx={{ whiteSpace: 'nowrap' }}
    >
      {isGenerating ? (
        <CircularProgress size={22} color='inherit' />
      ) : (
        'Generate'
      )}
    </Button>
    <Button
      variant='contained'
      disabled={!canGenerateOrDownload || isDownloading}
      onClick={onDownload}
      sx={{ whiteSpace: 'nowrap' }}
    >
      {isDownloading ? <CircularProgress size={22} /> : 'Download'}
    </Button>
  </SectionActions>
);

export default ActionButtons;
